import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import { getUser } from 'src/utils/Common';
import {text} from "../../modules/languages/index"
const useStyles = makeStyles((theme) => ({
  root: {},
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  startDateButton: {
    marginRight: theme.spacing(1)
  },
  endDateButton: {
    marginLeft: theme.spacing(1)
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const data = {
    name: SessionUser.FirstName +" " + SessionUser.LastName
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        component="h2"
        gutterBottom
        variant="overline"
      >
        
      </Typography>
      <Typography
        component="h1"
        gutterBottom
        variant="h3"
      >
        {text("iyi_gunler")},
        {' '}
        {data.name}
      </Typography>
      <Typography variant="subtitle1">
        Günün Özeti Aşağıdaki Gibidir!...
      </Typography>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
